module.exports = __webpack_public_path__ + "static/media/legal_before.43afa5c9.png";